module.exports = __webpack_public_path__ + "img/slogan-one-spirit-red.129e2f4c.svg";